import {
    isToday as dateFnsIsToday, differenceInSeconds,
    isFuture, isPast,
    format as originalFormat, formatDistanceToNowStrict as originalFormatDistanceToNowStrict, parseISO
} from 'date-fns';


export function formatDistanceToNowStrict(...params: Parameters<typeof originalFormatDistanceToNowStrict>) {
    const [ date ] = params;


    if (differenceInSeconds(new Date(), date) <= 10) {
        return 'just now';
    }

    return originalFormatDistanceToNowStrict(...params);
}

export function format(date: Date) {
    return originalFormat(date, 'MM/dd/yyyy');
}

export function parseAndFormatISO(dateStr: string) {
    return format(parseISO(dateStr));
}

/**
 * Converts a date to an ISO string without a time value, YYYY-MM-DD
 * i.e. 2023-02-12
 */
export function toISO(date: Date) {
    return date.toISOString().split('T')[0];
}

export function isPastDate(date: string | undefined) {
    return isValidDate(date) && isPast(parseISO(date));
}

export function isFutureDate(date: string | undefined) {
    return isValidDate(date) && isFuture(parseISO(date));
}

export function isToday(date: string | undefined) {
    return isValidDate(date) && dateFnsIsToday(parseISO(date));
}

export function formatDate(date: string | undefined, time?: boolean) {
    return isValidDate(date)
        ? originalFormat(parseISO(date), `MM/dd/yyyy ${time ? 'h:mmaaa' : ''}`)
        : 'Not a valid date';
}

function isValidDate(date: string | undefined): date is string {
    return !!Date.parse(date || '');
}
